import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import {memo} from 'react'

import {useAgentPoolIdParam} from '../../../../hooks/routes'
import useDocumentTitle from '../../../../hooks/useDocumentTitle'

import {getAgentPoolName} from './QueuePageHeader.selectors'

import styles from './QueuePageHeader.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {}

function QueuePageHeader() {
  const activeAgentPoolId = useAgentPoolIdParam()
  const agentPoolName = useAppSelector(state => getAgentPoolName(state, activeAgentPoolId))
  let title = 'Builds in Queue'

  if (agentPoolName != null) {
    title += ` in ${agentPoolName} pool`
  }

  useDocumentTitle(`${title} — TeamCity`)
  return <H1 className={styles.header}>{title}</H1>
}

export default memo<Props>(QueuePageHeader)
